import { Grid } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';

import WsColors from '../../WsColors';

const Footer = styled(Grid)(() => ({
  position: 'fixed',
  bottom: '10px',
  textAlign: 'center',
  width: '80vw',
  marginLeft: '5vw',
  borderRadius: '8px',
  background: WsColors.TheBlues900,
  padding: '20px 24px 20px 24px',
  zIndex: 100,
}));

export interface BottomActionBarProps {
  children: React.ReactNode;
}

const BottomActionBar = ({ children }: BottomActionBarProps) => (
  <Footer container>{children}</Footer>
);

export default BottomActionBar;
